
import { defineComponent } from 'vue'
import { getDispatch, DispatchDto, dispatchDelete, dispatchArchive } from '@/api/dispatch'
import { anit } from '@/utils/util'
import alertBox from '@/components/alert-box.vue'
import global from '@/utils/global'

export default defineComponent({
    name: 'Dispatch',
    components: {
        'alert-box': alertBox
    },
    data () {
        return {
            isViewVideo: false,
            videoList: [] as any[],
            searchValue: '',
            searchText: '',
            pageNum: 1,
            pageSize: 10,
            total: 0,
            sort: '',
            order: '',
            tableData: [] as DispatchDto[]
        }
    },
    created () {
        this.handleCurrentChange()
    },
    methods: {
        async handleCurrentChange () {
            const result = await getDispatch({
                page: this.pageNum,
                pageSize: this.pageSize,
                search: this.searchValue,
                sort: this.sort,
                order: this.order
            })
            this.tableData = result.data
            this.total = result.total
        },
        handleSortChange (column: { prop: string, order: string | null }) {
            this.sort = column.prop
            this.order = column.order === 'ascending' ? 'asc' : 'desc'
            if (column.order === null) {
                this.sort = ''
                this.order = ''
            }
            this.handleCurrentChange()
        },
        handleSizeChange () {
            this.pageNum = 1
            this.handleCurrentChange()
        },
        search () {
            this.searchValue = this.searchText
            this.pageNum = 1
            this.handleCurrentChange()
        },
        // 表格中根据状态筛选数据
        filterStatus (value: string) {
            // 使用anit防止多次触发
            if (anit()) {
                this.handleCurrentChange()
            }
            return true
        },
        async onDispatchDelete (id: number | string) {
            await this.$util.confirm('', '确定删除该被派遣单位？')
            await dispatchDelete({ companyId: id })
            await this.handleCurrentChange()
            this.$message.success('操作成功！')
        },
        async onDispatchArchive (id: number | string) {
            await this.$util.confirm('', '确定归档该被派遣单位？')
            await dispatchArchive({ companyId: id })
            await this.handleCurrentChange()
            this.$message.success('操作成功！')
        },
        preview (url: string) {
            window.open(url)
        },
        mutiPreview (row: { video: any[]; occupation: { occupation_id: string; name: string }[] }) {
            this.isViewVideo = true
            this.videoList = row.video

            const occupation: Record<string, string> = {}
            // 构建 occupation_id 到 name 的映射
            row.occupation.forEach((occ: { occupation_id: string; name: string }) => {
                // 确保 occupation_id 和 name 存在，避免 undefined
                if (occ.occupation_id && occ.name) {
                    occupation[occ.occupation_id] = occ.name
                }
            })

            if (row.video && Array.isArray(row.video)) {
                console.log(row.video, 879)
                row.video.forEach((video: { occupation_id: string; occupationTips: string[] }) => {
                    // 分割 occupation_id 字符串为数组（默认空数组）
                    const occupationIdMap = video.occupation_id
                        ? video.occupation_id.split(',').filter((id: string) => id) // 过滤空字符串
                        : []
                    console.log(video, 955)
                    if (video.occupation_id === '0' || video.occupation_id === '') {
                        return false
                    }
                    // 初始化 occupationTips 为数组（关键修复）
                    video.occupationTips = []

                    occupationIdMap.forEach((op: string) => {
                        // 只处理存在的 occupation 项，避免 undefined
                        if (occupation[op]) {
                            // 已有内容则加换行，否则直接赋值
                            video.occupationTips.push(occupation[op])
                        }
                    })
                })
            }
        },
        // 关闭预览视频
        onCancelViewVideo () {
            this.videoList = []
            this.isViewVideo = false
        },
        exportCompany () {
            window.location.href =
            process.env.VUE_APP_BASE_URL +
            '/company/export?token=' + global.token
            this.$message.success('导出成功')
        }
    }
})
